import React from "react";
import { useSelector } from "react-redux";
import { selectAuth } from "../../components/auth/auth.selector";
import GymAliasStructure from "../../components/gym-alias/GymAliasStructure";

const GymAlias = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData?.user || {};

  return <GymAliasStructure userInfoData={userInfoData} />;
};

export default GymAlias;
